// src/services/vehiclesService.js
import api from "@/services/api";
import { toast } from "vue3-toastify";

export const vehiclesService = {
  fetchTypes() {
    return api.get("/vehicles").catch(handleError);
  },

  fetchBrands(typeId) {
    return api.get(`/vehicles/${typeId}/brands`).catch(handleError);
  },

  fetchModels(typeId, brandId) {
    return api.get(`/vehicles/${typeId}/brands/${brandId}/models`).catch(handleError);
  },

  fetchYears(typeId, brandId, modelId) {
    return api.get(`/vehicles/${typeId}/brands/${brandId}/models/${modelId}/years`).catch(handleError);
  },

  fetchPrices(typeId, brandId, modelId, yearId) {
    return api.get(`/vehicles/${typeId}/brands/${brandId}/models/${modelId}/years/${yearId}`).catch(handleError);
  },
};

// Função para tratamento de erro
const handleError = (error) => {
  toast.error(error.response.data.message, {
    position: toast.POSITION.BOTTOM_RIGHT,
    theme: toast.THEME.COLORED,
    className: "foo-bar",
  });
  throw error;
};

export default vehiclesService;
